const state = {
  token: '',
  isAuthenticated: false,
  userInfo: {},
  userRoles: [],
  chatToken: ''
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/authentication/state.js